var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{attrs:{"href":_vm.link,"target":"_blank"}},[_c('div',{staticClass:"round_link"},[_c('v-icon',{domProps:{"innerHTML":_vm._s(_vm.icon)}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }